import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './components/AuthContext';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import Vehicles from './pages/Vehicles';
import SendMessage from './pages/SendMessage';
import History from './pages/History';
import TopUp from './pages/TopUp';
import Admin from './pages/Admin';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import VerifyEmail from './pages/VerifyEmail';
import ResendVerification from './pages/ResendVerification';
import Layout from './components/Layout';

const PrivateRoute = ({ children }) => {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
};

const PublicRoute = ({ children }) => {
  const { user } = useAuth();
  return !user ? children : <Navigate to="/dashboard" replace />;
};

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login"                element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/signup"               element={<PublicRoute><Signup /></PublicRoute>} />
          <Route path="/verify"               element={<VerifyEmail />} />
          <Route path="/forgot-password"      element={<PublicRoute><ForgotPassword /></PublicRoute>} />
          <Route path="/reset-password"       element={<PublicRoute><ResetPassword /></PublicRoute>} />
          <Route path="/resend-verification"  element={<ResendVerification />} />
          <Route path="/terms"                element={<Terms />} />
          <Route path="/privacy"              element={<Privacy />} />
          <Route path="/admin"                element={<Admin />} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="vehicles"  element={<Vehicles />} />
            <Route path="send"      element={<SendMessage />} />
            <Route path="history"   element={<History />} />
            <Route path="topup"     element={<TopUp />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
